function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#FF0017"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 6.546l1.225 3.769h3.963l-3.207 2.33 1.225 3.768L12 14.083l-3.206 2.33 1.224-3.769-3.206-2.33h3.963L12 6.547z",
  fill: "#FDFF12"
});

function SvgFlagVi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgFlagVi;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/flag-vi.svg
// module id = 1272
// module chunks = 10